<template>
    <aside class="_profile-data-column" :class="{
        '_profile-data-column-yandex': mode === 'yandex-pay-success',
    }">
        <h5 class="_profile-column-title">Данные</h5>
        <div class="_profile-hero-card">
            <h4 class="_profile-card-title">Данные</h4>
            <div class="_profile-info">
                <div class="_profile-info-row"><img src="@/assets/img/lk-phone.svg" />
                    <p>{{ user.phone.formatted }} </p>
                </div>
                <div class="_profile-info-row"><img src="@/assets/img/lk-letter.svg" />
                    <p>{{ user.email }}</p>
                </div>
            </div>
            <div class="_profile-hero-imgs">
                <img class="_profile-hero-imgs-side" src="@/assets/img/lk-hero-img-side.svg" alt="imgs-side">
                <img class="_profile-hero-imgs-center" src="@/assets/img/lk-hero-img-center.svg" alt="imgs-center">
                <img class="_profile-hero-imgs-side" src="@/assets/img/lk-hero-img-side.svg" alt="imgs-side">
            </div>
        </div>
    </aside>
</template>
<script>

export default {
    props: {
        mode: {
            type: String,
            default: 'default'
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
}
</script>
<style scoped lang="scss">
._profile-data-column {
    width: 312px;
    padding: 158px 0 30px;
}

._profile-data-column-yandex {
    border-right: 0;
}

._profile-column-title {
    width: 192px;
    font-family: 'Gilroy';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 140%;
    color: #828282;
    border: none;
    padding-bottom: 6px;
    margin-bottom: 33px;
    border-bottom: 1px solid #828282
}

._profile-hero-card {
    position: relative;
    width: 312px;
    height: 296px;
    padding: 50px 30px 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #F2F2F2;
    border-radius: 12px;

    ._profile-card-title {
        display: none;
    }

    ._profile-info-row {
        display: flex;
        width: 100%;
        padding-bottom: 6px;
        font-family: 'Gilroy';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333333;
        border-bottom: 1px solid #C4C4C4;

        p {
            padding-left: 7px;
        }
    }

    ._profile-info-row+._profile-info-row {
        margin-top: 36px;
    }

    ._profile-hero-imgs {
        display: flex;
        justify-content: space-between;

        ._profile-hero-imgs-side:nth-child(3) {
            transform: rotate(180deg);
        }
    }
}

@media screen and (max-width: 725px) {
    ._profile-data-column {
        width: 100%;
        flex-basis: 100%;
        border: 0;
        padding: 0;

        ._profile-card-title {
            display: block;
            padding: 0;
            font-weight: 700;
            margin-bottom: 10px;
            font-size: 18px;
            line-height: 22px;
            color: #333333;
        }

        ._profile-hero-card {
            width: 100%;
            height: auto;
            padding: 16px 10px 20px;

            ._profile-info-row {
                border-bottom: 1px solid #828282;
            }

            ._profile-info-row+._profile-info-row {
                margin-top: 16px;
            }

            ._profile-hero-imgs {
                display: none;
            }
        }
    }
}
</style>
